import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons/faCog";
import classNames from "classnames";
import { CSSProperties, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import styles from "./confirm-button.less";

type ConfirmButtonProps = {
    id: string;
    className: string;
    color?: "inherit" | "primary" | "secondary" | "default";
    size: "sm" | "lg";
    height?: any;
    width?: any;
    cornerRadius?: any;
    backgroundColor?: string;
    textColor?: string;
    buttonText?: string;
    borderWidth?: string;
    borderColor?: string;
    type?: string;
    useCustomText?: boolean;
    submitButtonType?: any;
    isSubmitButton?: boolean;
    isSubmitting?: boolean;
    disabled?: boolean;
    onClick?: () => void;
};

export const ConfirmButton = (props: ConfirmButtonProps) => {
    const {
        id,
        className,
        color,
        size,
        disabled,
        height,
        width,
        cornerRadius,
        backgroundColor,
        borderColor,
        textColor,
        buttonText,
        borderWidth,
        isSubmitting,
        isSubmitButton,
        onClick
    } = props;

    const buttonRef = useRef<HTMLButtonElement>(null);

    //need to be able to force not-allowed
    useEffect(() => {
        if (disabled && buttonRef.current) {
            buttonRef.current.style.setProperty("cursor", "not-allowed", "important");
        } else if (buttonRef.current) {
            buttonRef.current.style.removeProperty("cursor");
        }
    }, [disabled]);

    const buttonStyle: CSSProperties = {
        height,
        width,
        borderRadius: cornerRadius,
        backgroundColor: backgroundColor || undefined,
        color: textColor || undefined,
        borderWidth,
        borderColor: borderColor || "transparent",
    };

    const handleOnClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <Button
            ref={buttonRef}
            id={id}
            color={color}
            size={size}
            type={isSubmitButton ? 'submit' : 'button'}
            className={classNames(styles.confirmButton, className)}
            style={buttonStyle}
            disabled={disabled}
            onClick={handleOnClick}
        >
            <span>{buttonText}</span>
            {isSubmitting && <FontAwesomeIcon className={classNames(styles.cogIcon, "fa-spin")} icon={faCog} />}
        </Button>
    );
};